module.exports = __webpack_public_path__ + "static/media/vispnetLogo.98ffa035.svg";